<template>
  <c-app>
    <c-content>
      <section class="sign u-m-auto">
        <div class="sign__body">
          <header class="sign__header">
            <h1 class="sign__title">Actualizar Datos</h1>
            <p class="sign__text">Actualice su contraseña de Inicio de Sesión</p>
            <c-flash type="danger" :closeable="false" v-show="errorMessage != ''">{{ errorMessage }}</c-flash>
          </header>
          <c-form>
            <div class="u-color-grey-darkest u-text-center">Bienvenido <span class="u-font-bold">{{displayName}}</span>, es necesario actualizar tus datos de Inicio de Sesion</div>
            <c-divider></c-divider>
            <c-form-field v-show="emailupdate" label="Email">
              <c-form-input v-show="emailupdate"  v-model="email" type="email"></c-form-input>
            </c-form-field>
            <c-form-field label="Contraseña Actual">
              <c-form-input icon-start="icon-lock" v-model="currentpassword" type="password"></c-form-input>
            </c-form-field>
            <c-form-field label="Nueva Contraseña">
              <c-form-input icon-start="icon-lock" v-model="password" type="password"></c-form-input>
            </c-form-field>
            <c-form-field label="Repetir Contraseña">
              <c-form-input icon-start="icon-lock" v-model="passwordConfirm" type="password"></c-form-input>
            </c-form-field>
            <c-button type="primary" @click.prevent="register" block>Actualizar</c-button>
          </c-form>
          <div style="text-align:center;">
          <img src="../assets/rmgridlogoBlue.png" alt="rmgrid" style="width:50%;margin-top:20px;">
          </div>
        </div>
        <footer class="sign__footer u-text-center">
          <p>Ya tiene una Cuenta? <router-link to="/login">Inicie Sesión</router-link></p>
          <p class="u-text-muted u-fs-12">RMGRID by Riverminds Cia. Ltda.<br>© 2017-2018. Todos los Derechos Reservados.</p>
        </footer>
      </section>
    </c-content>
  </c-app>
</template>

<script>
  export default {
    name: 'RegisterView',
    props: ['propUsername','propEmailUpdate','propDisplayName'],
    data() {
      return {
        forgeryToken: window.forgeryToken,
        baseServiceUrl: window.baseServiceUrl,
        username: this.propUsername,
        displayName: this.propDisplayName,
        email: "",
        currentpassword: "",
        password: "",
        passwordConfirm: "",
        emailupdate: this.propEmailUpdate,
        errorMessage: ""

      }
    },
    methods: {
      register() {
          if (this.emailupdate == true && (this.email == false || this.email == ""))
          {

              this.$notify({
                type: 'danger',
                title: 'Actualización de Datos',
                content: 'Por favor ingrese el Email!',
                closeable: true,
                duration: 10000
              });
              return;
          }
          if (this.password != this.passwordConfirm)
          {

              this.$notify({
                type: 'danger',
                title: 'Actualización de Datos',
                content: 'La nueva contraseña no coincide con la verficación de la nueva contraseña!',
                closeable: true,
                duration: 10000
              });
              return;
          }
          if (this.password == false || this.password == "")
          {

              this.$notify({
                type: 'danger',
                title: 'Actualización de Datos',
                content: 'La contraseña esta en blanco!',
                closeable: true,
                duration: 10000
              });
              return;
          }
          if (this.password == this.currentpassword)
          {

              this.$notify({
                type: 'danger',
                title: 'Actualización de Datos',
                content: 'La nueva contraseña no puede ser la misma que la contraseña anterior, por favor ingrese una nueva contraseña',
                closeable: true,
                duration: 10000
              });
              return;
          }

          const vm = this.$toast.loading("Iniciando Sesión...");

        this.$http.post(baseServiceUrl + 'api/accountapi/updatepassword', {
          CurrentPassword: this.currentpassword,
          Password: this.password,
          Email: this.email
        }).then(function(response){
          vm.hide();
            this.$notify({
                type: 'success',
                title: 'Actualización de Datos',
                content: 'Se han actualizado sus Datos de Sesión!',
                closeable: true,
                duration: 10000
              });
            this.$router.replace('/login')
          
          }, function(e){

            vm.hide();
            if (e != null && e.body != null && e.body.Message != null)
            {
              this.errorMessage = e.body.Message;
            }

        });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/register.vue